module.exports = __webpack_public_path__ + "img/timi.638025e4.jpeg";